import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  commentConditionPostApi,
  getAllRestaurantCommentApi,
  getOrdersListApi,
  getUserInfoApi,
} from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import CommentById from "../../Modal/Information/CommentById/CommentById";
import CommentCondition from "../../Modal/Information/CommentCondition/CommentCondition";
import OrderListOfOneRestaurant from "../../Modal/Information/OrderListOfOneRestaurant/OrderListOfOneRestaurant";
import UserInfo from "../../Modal/Information/UserInfo/UserInfo";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import RestaurantCommentTable from "../../Tables/Comments/RestaurantCommentTable/RestaurantCommentTable";

const RestaurantCommentContainer = () => {
    const [comment, setComment] = useState([]);
    const [orderDetail, setOrderDetail] = useState([]);
    const [Info, setInfo] = useState([]);
    const [rawInfo, setRawInfo] = useState();
    const [statusIs, setStatusIs] = useState("");
    const [showOrders, setShowOrders] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [showCommentCondition, setShowCommentCondition] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  ///////// useEffect ////////
  useEffect(() => {
    getAllRestaurantComment();
    // getOrdersDetail()
  }, []);
  
  ////////// onclick open modal //////////
  const showAddress = async (id, info) => {
    ////////// oreder detail ////////
    getOrdersListApi(info.orderId, info.supId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setOrderDetail(res.orders);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })

    setRawInfo(info);

    if (id === 1) {
      setStatusIs("-1");
      setShowCommentCondition(true);
    }

    if (id === 2) {
      let commentInfo = {
        id: info.commentId,
        status: "1",
        cause: "",
      };
      commentConditionPostApi(commentInfo, (suc) => {
        if (suc.status === 1) {
          succToast(suc.message);
        } else {
          errorToast(suc.message);
        }
      });
      getAllRestaurantComment();
    }

    if (id === 3) {
      setShowComment(true);
    }

    if (id === 4) {
      setShowOrders(true);
    }
    if (id === 5) {
      const result2 = await getUserInfoApi(info.userId);
      setInfo(result2.info);
      setShowInfo(true);
    }
  };
  ///////// onclick close modal /////////
  const handleOkAddress = () => {
    setShowOrders(false);
    setShowComment(false);
    setShowCommentCondition(false);
    setShowInfo(false);
  };
  ///////// get comments //////////
  const getAllRestaurantComment = async () => {
    getAllRestaurantCommentApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setComment(res.comments);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  ///////// data table //////////
  const data =
    comment &&
    comment.map((item, index) => {
      return {
        key: index,
        restaurantName: item.supplier_name,
        customerName: item.user_fullname,
        city: item.city,
        date: item.date,
        score: item.score,
        comment: item.comment,
        status: item.status,
        supId: item.supplier_id,
        orderId: item.order_id,
        userId: item.user_id,
        commentId: item.id,
      };
    });
  /////// style /////////
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
  };

  return (
    <div>
      <Modal show={showComment} onHide={handleOkAddress}>
        <Modal.Body>
          <CommentById rawInfo={rawInfo} handleOk={handleOkAddress} />
        </Modal.Body>
      </Modal>

      <Modal show={showCommentCondition} onHide={handleOkAddress}>
        <Modal.Body>
          <CommentCondition
            statusIs={statusIs}
            rawInfo={rawInfo}
            handleOk={handleOkAddress}
            getAllComment={getAllRestaurantComment}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showInfo} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات مشتری</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserInfo
            Info={Info}
            showAddress={false}
            handleOk={handleOkAddress}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showOrders} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>سفارشات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrderListOfOneRestaurant
            orderDetail={orderDetail}
            rawInfo={rawInfo}
            handleOk={handleOkAddress}
          />
        </Modal.Body>
      </Modal>

      <TableFixedPage title={"نظرات رستوران"} />
      <RestaurantCommentTable
        rawInfo={rawInfo}
        showAddress={showAddress}
        data={data}
      />
    </div>
  );
};

export default RestaurantCommentContainer;
